var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.config.ui_version == 3.7)?_c('tabbar3Dian7',{attrs:{"active":_vm.active}}):(['3.8','3.8_2'].includes(_vm.config.ui_version))?_c('tabbar3Dian8',{attrs:{"active":_vm.active}}):_c('tabbar',{attrs:{"active":_vm.active}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }